<form
  class="max-w-lg h-full mx-auto bg-white divide-y divide-gray-200 border rounded-xl shadow-lg"
  aria-label="Filters"
>
  <header *ngIf="!isPreview" class="p-6 text-center">
    <div class="flex justify-between text-sm font-medium text-gray-600">
      <div
        class="text-sm font-normal text-red-600 cursor-pointer"
        (click)="resetValue()"
      >
        Reset values
      </div>
      <div
        class="font-normal cursor-pointer text-primary-500 hover:underline"
        (click)="goBack()"
      >
        <pulse-icon [size]="12" icon="pencil"></pulse-icon>
        Edit
      </div>
    </div>
  </header>

  <main class="flow-root p-6 w-96">
    <div class="-my-8 divide-y divide-gray-200">
      <div class="py-8">
        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">
            COUNTRY
          </legend>

          <label class="block text-left mb-4 pb-4 border-b">
            <pulse-chip>
              <span class="font-light text-xs">{{ filter.country.name }}</span>
            </pulse-chip>
          </label>
        </fieldset>

        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">
            LOCATION
          </legend>

          <ng-container
            *ngIf="
              filter?.location?.state?.length ||
                filter?.location?.additionalFields?.length;
              else noResults
            "
          >
            <ul class="grid gap-4 mt-6">
              <li *ngIf="filter?.location?.state?.length">
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">State</span>
                </label>
                <ng-container *ngFor="let state of filter.location.state">
                  <pulse-chip>
                    <span class="font-light text-xs">{{
                      state.description
                    }}</span>
                  </pulse-chip>
                </ng-container>
              </li>

              <li *ngIf="filter?.location?.province?.length">
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">Province</span>
                </label>
                <ng-container *ngFor="let province of filter.location.province">
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ province.description }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
              <li *ngIf="filter?.location?.city?.length">
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">City</span>
                </label>
                <ng-container *ngFor="let city of filter.location.city">
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ city.description }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
              <li *ngIf="filter?.location?.postalCode">
                <label class="flex items-center text-sm">
                  <span class="mr-3 font-medium">Postal code:</span>
                  <span class="mr-3 font-light text-sm">{{
                    filter.location.postalCode
                  }}</span>
                </label>
              </li>
            </ul>
            <ul>
              <li *ngIf="filter?.location?.additionalFields.length">
                <label class="flex items-center text-sm">
                  <div class="font-medium my-4">Additional fields</div>
                </label>
                <ng-container
                  *ngFor="let field of filter.location.additionalFields"
                >
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ field.label }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
            </ul>
          </ng-container>
        </fieldset>
      </div>

      <div class="py-8">
        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">
            COMPANY SIZE
          </legend>

          <ng-container
            *ngIf="
              filter?.size?.employees?.length ||
                filter?.size?.additionalFields.length;
              else noResults
            "
          >
            <ul class="grid grid-cols-1 gap-4 mt-6">
              <li *ngIf="filter.size.employees.length">
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">Employees</span>
                </label>
                <ng-container *ngFor="let employees of filter.size.employees">
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ employees.description }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>

              <li *ngIf="filter.size.revenue.length">
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">Revenue</span>
                </label>
                <ng-container *ngFor="let revenue of filter.size.revenue">
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ revenue.description }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
            </ul>
            <ul>
              <li *ngIf="filter?.size?.additionalFields.length">
                <label class="flex items-center text-sm">
                  <div class="font-medium my-4">Additional fields</div>
                </label>
                <ng-container
                  *ngFor="let field of filter.size.additionalFields"
                >
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ field.label }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
            </ul>
          </ng-container>
        </fieldset>
      </div>

      <div class="py-8">
        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">
            INDUSTRY
          </legend>

          <ng-container
            *ngIf="filter?.industries?.industry?.length; else noResults"
          >
            <ul class="grid grid-cols-1 gap-4 mt-6">
              <li>
                <label class="text-sm">
                  <ng-container
                    *ngFor="let industry of filter.industries.industry"
                  >
                    <div class="block m-2 text-xs">
                      {{ industry.description }}
                    </div>
                  </ng-container>
                </label>
              </li>
              <li *ngIf="filter?.industries?.additionalFields.length">
                <label class="flex items-center text-sm">
                  <span class="font-medium">Additional fields</span>
                </label>
                <ng-container
                  *ngFor="let field of filter.industries.additionalFields"
                >
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ field.label }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
            </ul>
          </ng-container>
        </fieldset>
      </div>

      <div class="py-8">
        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">TYPE</legend>
          <ng-container
            *ngIf="
              filter?.type?.ownership?.length ||
                filter?.type?.taxStatus?.length;
              else noResults
            "
          >
            <ul class="grid grid-cols-1 gap-4 mt-6">
              <li>
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">Ownership type</span>
                </label>

                <ng-container
                  *ngIf="filter?.type?.ownership?.length; else noResults"
                >
                  <ng-container *ngFor="let ownership of filter.type.ownership">
                    <pulse-chip>
                      <span class="font-light text-xs">
                        {{ ownership.description }}
                      </span>
                    </pulse-chip>
                  </ng-container>
                </ng-container>
              </li>

              <li>
                <label class="flex items-center text-sm">
                  <span class="mb-3 font-medium">Tax status</span>
                </label>
                <ng-container
                  *ngIf="filter?.type?.taxStatus?.length; else noResults"
                >
                  <ng-container *ngFor="let taxStatus of filter.type.taxStatus">
                    <pulse-chip>
                      <span class="font-light text-xs">
                        {{ taxStatus.description }}
                      </span>
                    </pulse-chip>
                  </ng-container>
                </ng-container>
              </li>

              <li *ngIf="filter?.type?.additionalFields.length">
                <label class="flex items-center text-sm">
                  <span class="font-medium">Additional fields</span>
                </label>
                <ng-container
                  *ngFor="let field of filter.type.additionalFields"
                >
                  <pulse-chip>
                    <span class="font-light text-xs">
                      {{ field.label }}
                    </span>
                  </pulse-chip>
                </ng-container>
              </li>
            </ul>
          </ng-container>
        </fieldset>
      </div>

      <div class="py-8">
        <fieldset>
          <legend class="text-sm font-medium text-secondary-900">
            FINANCIALS
          </legend>

          <ng-container *ngIf="!noResults; else noResults"></ng-container>
        </fieldset>
      </div>
    </div>
  </main>
</form>

<ng-template #noResults
  ><div class="block text-center pt-8 text-sm">Filter not selected</div>
</ng-template>
